"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hierarchy = void 0;
exports.Hierarchy = { parse };
function parse(e) {
    return Object.entries(e).reduce((h, [keystring, pointCount]) => {
        if (pointCount === -1)
            h.pages[keystring] = {};
        else if (pointCount)
            h.nodes[keystring] = { pointCount };
        return h;
    }, { nodes: {}, pages: {} });
}
